/**
 * Motion preferences for the JS-driven transitions (sheets, panels).
 *
 * Keyframe entrances in globals.css are gated by prefers-reduced-motion
 * themselves; an inline transition is not, so a sheet asks here. Under
 * "reduce" a sheet still changes state visibly, as a cross-fade: that
 * is what the setting asks for (no movement), not a snap.
 */

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
}

export function isPhoneWidth(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return true;
  try {
    return window.matchMedia("(max-width: 639px)").matches;
  } catch {
    return true;
  }
}
